import React from 'react';

export default function Title({
    hn = 'span',
    textTitle = '',
    className = ''
}) {
    switch (hn) {
        case 'h1':
        return <h1 className={className}>{textTitle}</h1>;
        case 'h2':
        return <h2 className={className}>{textTitle}</h2>;
        case 'h3':
        return <h3 className={className}>{textTitle}</h3>;
        case 'h4':
        return <h4 className={className}>{textTitle}</h4>;
        case 'h5':
        return <h5 className={className}>{textTitle}</h5>;
        case 'h6':
            return <h6 className={className}>{textTitle}</h6>;
        default:
            return <span className={className}>{textTitle}</span>;
    }
}
